import { useLayoutEffect, useRef } from "react";
import { getFocusableElements } from "../../../common/utils/dom.ts";
import { ManageAssetWithLicense } from "../../../common/api/decimal/common-types/manageAssets.ts";
import AssetCard from "../common/cards/AssetCard.tsx";

export default function LibraryAssetChunk({
  assets,
  focusFirstCard = true,
}: {
  assets: ManageAssetWithLicense[];
  focusFirstCard?: boolean;
}) {
  const firstCardRef = useRef<HTMLLIElement>(null);

  useLayoutEffect(() => {
    if (focusFirstCard && firstCardRef.current) {
      getFocusableElements(firstCardRef.current)[0]?.focus();
    }
  }, [focusFirstCard]);

  return assets.map((asset, i) => (
    <AssetCard
      key={asset.manageAsset.vbid}
      asset={asset}
      lazyLoad={i > 20}
      ref={i === 0 ? firstCardRef : undefined}
      hideOnReturn={true}
    />
  ));
}
